/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomEliteConfigurationModelDto } from '../../models/custom-elite-configuration-model-dto';

export interface CustomEliteConfigurationControllerUpdateConfiguration$Params {
  uuid: string;
      body: CustomEliteConfigurationModelDto
}

export function customEliteConfigurationControllerUpdateConfiguration(http: HttpClient, rootUrl: string, params: CustomEliteConfigurationControllerUpdateConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomEliteConfigurationModelDto>> {
  const rb = new RequestBuilder(rootUrl, customEliteConfigurationControllerUpdateConfiguration.PATH, 'put');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomEliteConfigurationModelDto>;
    })
  );
}

customEliteConfigurationControllerUpdateConfiguration.PATH = '/custom-elite-configuration/{uuid}';
